import React, { useState } from 'react';
import { Upload, Button, message, Table, Radio } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { CreateAllData } from '@/apiError/apiCreate';

const Check = () => {
  const [jsonData, setJsonData] = useState({});
  const [selectedSheet, setSelectedSheet] = useState('');

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      let allSheetsData = {};
      workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        allSheetsData[sheetName] = XLSX.utils.sheet_to_json(sheet);
      });

      setJsonData(allSheetsData);
      setSelectedSheet(Object.keys(allSheetsData)[0]);
      message.success('Excel file converted successfully!');
    };

    reader.readAsArrayBuffer(file);
    return false;
  };

  const prepareDataForSubmission = () => {
    if (!jsonData || Object.keys(jsonData).length < 3) {
      message.error('Ensure the file has at least three sheets.');
      return null;
    }

    const sheetNames = Object.keys(jsonData);
    const openingStockJson = jsonData[sheetNames[0]][0] || {}; // Convert array to object
    const itemDetails = jsonData[sheetNames[1]];
    const diamondStoneData = jsonData[sheetNames[2]];
    const structuredData = {
      openingStockJson,
      itemDetails: itemDetails?.map((item) => ({
        ...item,
        codeWindowId: `${Math.random()}`,
        diamondStoneJson: diamondStoneData?.filter(
          (diamond) => diamond?.item_detail_id === item.id,
        ),
      })),
    };

    return structuredData;
  };

  const handleSubmit = async () => {
    const dataToSend = prepareDataForSubmission();
    if (!dataToSend) return;

    try {
      await CreateAllData.createItem(
        '/transaction/opening-stocks/',
        dataToSend,
      );
      message.success('JSON data submitted successfully!');
    } catch (error) {
      message.error('Failed to submit data!');
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <Upload beforeUpload={handleFileUpload} showUploadList={false}>
        <Button icon={<UploadOutlined />}>Upload Excel</Button>
      </Upload>

      {jsonData && Object.keys(jsonData).length > 0 && (
        <>
          <h3>Select Sheet to View:</h3>
          <Radio.Group
            value={selectedSheet}
            onChange={(e) => setSelectedSheet(e.target.value)}
          >
            {Object.keys(jsonData).map((sheetName) => (
              <Radio key={sheetName} value={sheetName}>
                {sheetName}
              </Radio>
            ))}
          </Radio.Group>

          {selectedSheet && jsonData[selectedSheet] && (
            <div style={{ marginTop: 20 }}>
              <h3>Sheet: {selectedSheet}</h3>
              <Table
                bordered
                scroll={{ x: 500 }}
                dataSource={jsonData[selectedSheet]}
                columns={
                  jsonData[selectedSheet].length > 0
                    ? Object.keys(jsonData[selectedSheet][0]).map((key) => ({
                        title: key,
                        dataIndex: key,
                        key,
                      }))
                    : []
                }
                rowKey={(record, index) => index}
                pagination={{ pageSize: 5 }}
              />
            </div>
          )}

          <Button
            type="primary"
            onClick={handleSubmit}
            style={{ marginTop: 10 }}
          >
            Submit JSON to Backend
          </Button>
        </>
      )}
    </div>
  );
};

export default Check;
